import { API } from './API';

const DEFAULT_OPTIONS = {
  prefix: 'ACTIVITY/',
  baseUrl: 'activity',
};

export class ActivityAPI extends API {
  constructor(options = {}) {
    super({ ...DEFAULT_OPTIONS, ...options });
  }

  get() {
    return Promise.resolve({});
  }

  // get({
  //   orgId,
  //   role,
  //   startDate,
  //   endDate,
  //   sortDir,
  //   limit,
  // }) {
  //   const params = [orgId];
  //   const query = {
  //     role,
  //     startDate: startDate ? moment(startDate).format(DATE_FORMAT) : undefined,
  //     endDate: endDate ? moment(endDate).format(DATE_FORMAT) : undefined,
  //     sortDir,
  //     limit,
  //   };
  //   return super.get({ params, query });
  // }
}



// WEBPACK FOOTER //
// ./src/lib/api/ActivityAPI.js